module.exports = __webpack_public_path__ + "assets/img/4.3b5a3bbf.jpg";